/**
 * Format rank number for display
 * 
 * @param rank - The rank number to format
 * @returns Formatted rank string with appropriate prefix
 * 
 * Display logic:
 * - 1-100: Show exact number (e.g., "#1", "#88")
 * - 101-500: Show "100+"
 * - 501-1000: Show "500+"
 * - 1001-5000: Show "1000+"
 * - 5001-6000: Show "5000+"
 * - Above 6000: Show "~"
 */
export function formatRank(rank: number): string {
  if (rank <= 0) {
    return '~';
  }

  if (rank <= 100) {
    return `#${rank}`;
  }

  if (rank <= 500) {
    return '#100+';
  }

  if (rank <= 1000) {
    return '#500+';
  }

  if (rank <= 5000) {
    return '#1000+';
  }

  if (rank <= 6000) {
    return '#5000+';
  }

  return '~';
}

/**
 * Calculate like percentage from likes and dislikes
 * 
 * @param likes - Number of likes
 * @param dislikes - Number of dislikes
 * @returns Percentage of likes (0-100)
 */
export function calculateLikePercentage(likes: number, dislikes: number): number {
  const total = likes + dislikes;
  if (total === 0) return 0;
  return Math.round((likes / total) * 100);
}

/**
 * Calculate dislike percentage from likes and dislikes
 * 
 * @param likes - Number of likes
 * @param dislikes - Number of dislikes
 * @returns Percentage of dislikes (0-100)
 */
export function calculateDislikePercentage(likes: number, dislikes: number): number {
  const total = likes + dislikes;
  if (total === 0) return 0;
  return Math.round((dislikes / total) * 100);
}
